<template>
  <b-card>
    <documento-list
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :mensagem-remocao="mensagemRemocao"
      :filtros="filtros"
      filtrar-por-ativo
    />
  </b-card>
</template>

<style lang="scss">
</style>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '@/app-modulo/documento/documento/shared/services/api'

export default {
  name: 'DocumentoVisualizacao',
  components: {
    DocumentoList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Descrição', field: 'descricao', type: 'personalizada', showActive: true, editable: true,
        },
        { label: 'Departamento', field: 'departamentoNome' },
        { label: 'Periodicidade', field: 'periodicidadeDesc' },
      ],
      filtros: [{ colunas: ['Descricao', 'DepartamentoNome', 'PeriodicidadeDesc'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
      mensagemRemocao: 'Digite sua senha para confirmar a exclusão.',
    }
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getDocumentos(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-documento' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-documento', params: { id: value.id } })
    },
    remover(itens) {
      const itensInner = itens
      return new Promise(resolve => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < itensInner.length; i++) {
          const item = itensInner[i]
          api.deleteDocumento(item.id)
            .then(() => {
              // tenporario
              if (i === itensInner.length - 1) {
                resolve()
              }
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response.data.message || err.message,
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              })
              throw err
            })
        }
      })
    },
  },
}
</script>
